function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "nxkooi67ja",
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2278 -483) translate(1922 467) translate(356 16)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "u4fzrptqlb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#nxkooi67ja"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#263238",
  fillRule: "nonzero",
  xlinkHref: "#nxkooi67ja"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#u4fzrptqlb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24.24V24.24H0z"
}))))));
function SvgIconsMaterialCloseDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMaterialCloseDefault);
export default __webpack_public_path__ + "static/media/icons-material-close-default.4f639a92c8e1765db0223751764ba16a.svg";
export { ForwardRef as ReactComponent };